import React from 'react';

const SvgTrash = ({ svgRef, title, ...props }) => (
  <svg viewBox="0 0 10 11" ref={svgRef} {...{ ...{ width: '1em', height: '1em' }, ...props }}>
    <title>{title}</title>
    <path fill="currentColor" d="M2.5 2.5h5v7h-5zM3 0v1H0v1.5h1V11h8V2.5h1V1H7V0z" />
  </svg>
);

const ForwardRef = React.forwardRef((props, ref) => <SvgTrash svgRef={ref} {...props} />);
export default ForwardRef;



// WEBPACK FOOTER //
// ./src/common/icons/Trash.js